import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { Hero } from "@/components/sections/Hero";
import { QuickBenefits } from "@/components/sections/QuickBenefits";
import { HowItWorksCycle } from "@/components/sections/HowItWorksCycle";
import { LiveResults } from "@/components/sections/LiveResults";
import { Calculator } from "@/components/sections/Calculator";
import { Pricing } from "@/components/sections/Pricing";
import { WhyNow } from "@/components/sections/WhyNow";
import { FreeAccessSteps } from "@/components/sections/FreeAccessSteps";
import { DownloadsBlock } from "@/components/sections/DownloadsBlock";
import { FaqBlock } from "@/components/sections/FaqBlock";
import { PurchaseEnquiryModal } from "@/components/overlays/PurchaseEnquiryModal";
import { PageError, PageLoader } from "@/components/ui/PageStates";
import { useContent } from "@/lib/content-context";

export default function LandingPage() {
  const { data, loading, error } = useContent();
  const [plan, setPlan] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    document.title = "Goldmap EA - automated XAUUSD trading for MT4 and MT5";
  }, []);

  useEffect(() => {
    if (!data) return;
    const hash = location.hash?.replace("#", "");
    if (!hash) return;
    const id = window.setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 260);
    return () => window.clearTimeout(id);
  }, [data, location.hash]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const openEnquiry = (selected) => {
    setPlan(selected);
    setModalOpen(true);
  };

  if (loading) {
    return (
      <SiteLayout config={null}>
        <PageLoader label="Loading Goldmap..." />
      </SiteLayout>
    );
  }

  if (error || !data) {
    return (
      <SiteLayout config={null}>
        <PageError onRetry={() => window.location.reload()} />
      </SiteLayout>
    );
  }

  return (
    <SiteLayout config={data.config} availability={data.availability}>
      <Hero
        config={data.config}
        availability={data.availability}
        onPrimary={() => scrollTo("pricing")}
        onSecondary={() => scrollTo("how-it-works")}
      />
      <QuickBenefits benefits={data.benefits} />
      <HowItWorksCycle steps={data.cycle_steps} />
      <LiveResults stats={data.stats} config={data.config} />
      <Calculator />
      <Pricing
        plans={data.plans}
        config={data.config}
        availability={data.availability}
        onEnquire={openEnquiry}
      />
      <WhyNow reasons={data.why_now} availability={data.availability} />
      <FreeAccessSteps
        steps={data.free_access_steps}
        config={data.config}
        availability={data.availability}
      />
      <DownloadsBlock builds={data.downloads?.builds || data.downloads} config={data.config} />
      <FaqBlock categories={data.faq_categories} faqs={data.faqs} limit={6} />

      <PurchaseEnquiryModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        plan={plan}
        config={data.config}
      />
    </SiteLayout>
  );
}
